export const NOT_PAYED = {
  value: "NOT_PAYED",
  key: "memberCoverages.inactivityReasons.notPaid",
};
export const PERMANENT_DEACTIVATION = {
  value: "PERMANENT_DEACTIVATION",
  key: "memberCoverages.inactivityReasons.withdrawnPermanentlyClean",
};
export const ANNUAL_DEACTIVATION = {
  value: "ANNUAL_DEACTIVATION",
  key: "memberCoverages.inactivityReasons.withdrawnYearlyClean",
};
export const SESSION_DEACTIVATION = {
  value: "SESSION_DEACTIVATION",
  key: "memberCoverages.inactivityReasons.withdrawnSessionallyClean",
};
export const OTHER = {
  value: "OTHER",
  key: "memberCoverages.inactivityReasons.otherClean",
};

export default [NOT_PAYED, PERMANENT_DEACTIVATION, ANNUAL_DEACTIVATION, OTHER];



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/members/member/dependents/coverages/enums/dependentCoverageInactivityReasons.js